import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { amendOrderEpic } from './amendOrderEpic';
import { cancelOrderEpic } from './cancelOrderEpic';
import { fetchKycStatusEpic } from './fetchKycStatusEpic';
import { fetchLinkedToClientEpic } from './fetchLinkedtoClientEpic';
import { fetchSettlementTypesEpic } from './fetchSettlementTypesEpic';
import { initCpOrderFormEpic } from './initCpOrderFormEpic';
import { loadNewSettlementDateEpic } from './loadNewSettlementDateEpic';
import { placeOrderEpic } from './placeOrderEpic';
import { reloadCpOrderFormEpic } from './reloadCpOrderFormEpic';

export const secondaryMarketCpOrder = () =>
  combineEpics(
    withAppCrashIfException('amendOrderEpic', amendOrderEpic()),
    withAppCrashIfException('cancelOrderEpic', cancelOrderEpic()),
    withAppCrashIfException('fetchKycStatusEpic', fetchKycStatusEpic()),
    withAppCrashIfException('fetchLinkedToClientEpic', fetchLinkedToClientEpic()),
    withAppCrashIfException('fetchSettlementTypesEpic', fetchSettlementTypesEpic()),
    withAppCrashIfException('initCpOrderFormEpic', initCpOrderFormEpic()),
    withAppCrashIfException('loadNewSettlementDateEpic', loadNewSettlementDateEpic()),
    withAppCrashIfException('placeOrderEpic', placeOrderEpic()),
    withAppCrashIfException('reloadCpOrderFormEpic', reloadCpOrderFormEpic()),
  );
